module.exports = __webpack_public_path__ + "img/bg_register.d808c26f.png";